export default __webpack_public_path__ + "static/media/crossicon.e9c8ccbc.svg";